import { Paper, Box, Stack, Typography, Skeleton } from '@mui/material';

/**
 * A single number with its label — dashboard and platform overview currency.
 * `tone` tints the value only (e.g. warning for outstanding join requests);
 * everything else stays neutral so a row of tiles reads as one object.
 */
const StatTile = ({ label, value, hint, icon, tone, loading, onClick, sx }) => (
  <Paper
    onClick={onClick}
    sx={{
      p: 2,
      height: '100%',
      cursor: onClick ? 'pointer' : 'default',
      transition: (t) => `border-color ${t.transitions.duration.shorter}ms`,
      '&:hover': onClick ? { borderColor: 'grey.300', bgcolor: 'grey.50' } : undefined,
      ...sx,
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      {icon && <Box sx={{ color: 'text.disabled', display: 'flex' }}>{icon}</Box>}
    </Stack>

    {loading ? (
      <Skeleton width={64} height={40} sx={{ my: 0.5 }} />
    ) : (
      <Typography variant="h1" sx={{ my: 0.5, color: tone || 'text.primary' }}>
        {value ?? 0}
      </Typography>
    )}

    {hint && <Typography variant="caption" color="text.secondary">{hint}</Typography>}
  </Paper>
);

export default StatTile;
